export const NETWORK_ERROR = 'NETWORK_ERROR';
const httpSuccessCodes = [200, 201, 202, 203, 204];

function handleResourceSuccess(dispatch, payload, action, errorAction) {
    if (httpSuccessCodes.includes(payload.status) && payload.data != null) {
        return dispatch(action);
    }

    if (!errorAction) {
        errorAction = { type: NETWORK_ERROR, error: payload.message };
    }
    return dispatch(errorAction);
}

function handleResourceError(dispatch, error, info) {
    // eslint-disable-next-line no-console
    console.error(info ? `${info} - ${error}` : error);
    return dispatch({ type: NETWORK_ERROR, error });
}

export {
    handleResourceSuccess,
    handleResourceError
};



// WEBPACK FOOTER //
// ./helpers/resource-handlers.js